import {SvgProps} from '../svgProps';
import {useSvg} from '../useSvg';

export const DurationSvg = (props: SvgProps) => {
  const {fill, gradientMaybe} = useSvg(props);
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={props.className}
    >
      <path
        d='M24 48C20.6667 48 17.5449 47.3671 14.6347 46.1013C11.7227 44.8338 9.18933 43.1218 7.03467 40.9653C4.87822 38.8107 3.16622 36.2773 1.89867 33.3653C0.632889 30.4551 0 27.3333 0 24C0 20.6667 0.632889 17.544 1.89867 14.632C3.16622 11.7218 4.87822 9.18845 7.03467 7.032C9.18933 4.87733 11.7227 3.16711 14.6347 1.90133C17.5449 0.633777 20.6667 0 24 0C27.3333 0 30.456 0.633777 33.368 1.90133C36.2782 3.16711 38.8116 4.87733 40.968 7.032C43.1227 9.18845 44.8338 11.7218 46.1013 14.632C47.3671 17.544 48 20.6667 48 24C48 27.3333 47.3671 30.4551 46.1013 33.3653C44.8338 36.2773 43.1227 38.8107 40.968 40.9653C38.8116 43.1218 36.2782 44.8338 33.368 46.1013C30.456 47.3671 27.3333 48 24 48ZM31.4667 35.2L35.2 31.4667L26.6667 22.9333V10.6667H21.3333V25.0667L31.4667 35.2Z'
        fill={fill}
      />
      <defs>{gradientMaybe}</defs>
    </svg>
  );
};
